const SMALL = 500;
const MEDIUM = 900;
export {
  MEDIUM,
  SMALL
};
//# sourceMappingURL=_constants.js.map
